<template>
  <div class="image-container set-full-height" style="">
    <!--   Creative Tim Branding   -->

    <!--  Made With Paper Kit  -->

    <!--   Big container   -->
    <div class="container">
      <div class="row">
        <div class="col-sm-8 col-sm-offset-2" style="background-color:aquamarine">

          <h3 align="center" style="color:#000; font-family:Prompt">ระบบทำบัตรออนไลน์ คณะแพทยศาสตร์
            ม.สงขลานครินทร์</h3>
          <!--      Wizard container        -->
          <div class="wizard-container">
            <div class="card wizard-card" data-color="orange" id="wizardProfile">
              <div align="right">
                <span style="font-weight: bold;color: #3c763d">{{ ShowinfoMe }}</span>
                <v-btn
                    v-if="ShowinfoMe == ''"
                    outlined
                    color="primary"
                    style="margin-right: 25px;transform: scale(0.8)"
                    @click="Login">
                  เข้าสู่ระบบ
                </v-btn>
                <v-btn
                    v-if="ShowinfoMe != ''"
                    outlined
                    color="red"
                    style="margin-right: 25px;transform: scale(0.8)"
                    @click="Logout">
                  ออกจากระบบ
                </v-btn>
              </div>
              <div class="wizard-header text-center">
                <div class="tab-content">
                  <div class="row">
                    <div class="col-sm-8 col-sm-offset-2">
                      <div class="col-sm-6">
                        <div class="choice" data-toggle="wizard-checkbox"
                             @click="RegisterEmp">
                          <input type="checkbox" name="jobb" value="Design">
                          <div class="card card-checkboxes card-hover-effect"
                               style="background-color: aliceblue">
                            <img src="../assets/img/7.png"
                                 style="width:90px; height:60px;">
                            <p align="center" style="color:#333; font-family:Prompt">
                              บัตรบุคลากร</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="choice" data-toggle="wizard-checkbox"
                             @click="RegisterRelative">
                          <input type="checkbox" name="jobb" value="Code">
                          <div class="card card-checkboxes card-hover-effect"
                               style="background-color: aliceblue">
                            <img src="../assets/img/5.png"
                                 style="width:90px; height:60px;">
                            <p align="center"
                               style="color:#333; font-family:Prompt">
                              บัตรญาติบุคลากร</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="choice" data-toggle="wizard-checkbox"
                             @click="RegisterShop">
                          <input type="checkbox" name="jobb" value="Develop">
                          <div class="card card-checkboxes card-hover-effect"
                               style="background-color: aliceblue">
                            <img src="../assets/img/8.png"
                                 style="width:90px; height:60px;">
                            <p align="center"
                               style="color:#333; font-family:Prompt">
                              บัตรผู้ประกอบการ,ร้านค้า</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="choice" data-toggle="wizard-checkbox"
                             @click="RegisterFollow">
                          <input type="checkbox" name="jobb" value="Develop">
                          <div class="card card-checkboxes card-hover-effect"
                               style="background-color: aliceblue">
                            <img src="../assets/img/6.png"
                                 style="width:90px; height:60px;">
                            <p align="center"
                               style="color:#333; font-family:Prompt">
                              ติดตามการขออนุมัติทำบัตร</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div align="center" style="justify-content: center;text-align: center;width: 100%;margin-top: 15px">
                      <a href="https://medhr.medicine.psu.ac.th/PDPA/index" target="_blank" style="font-weight: bold;font-size: 20px;border: 3px red solid;border-radius: 5px;padding: 20px">**** จัดทำข้อตกลง PDPA ****</a>
                    </div>
                    <div class="col-sm-8 col-sm-offset-2">
                      <div class="col-sm-12">
                        <!--<div class="choice" data-toggle="wizard-checkbox"
                             @click="ManageCard">
                            <input type="checkbox" name="jobb" value="Develop">
                            <div class="card card-checkboxes card-hover-effect">
                                <img src="../assets/img/6.png"
                                     style="width:90px; height:60px;">
                                <p align="center"
                                   style="color:#333; font-family:Prompt">
                                    จัดการข้อมูลบัตร (เฉพาะเจ้าหน้าที่)</p>
                            </div>
                        </div>-->

                        <div class="choice" data-toggle="wizard-checkbox"
                             @click="ManageHR" v-if="MenuHR">
                          <input type="checkbox" name="jobb" value="Develop">
                          <div class="card card-checkboxes card-hover-effect"
                               style="background-color: antiquewhite">
                            <img src="../assets/img/CheckCard.png"
                                 style="width:90px; height:60px;">
                            <p align="center"
                               style="color:#333; font-family:Prompt">
                              จัดการข้อมูลบัตร (เฉพาะเจ้าหน้าที่ HR)</p>
                          </div>
                        </div>
                        <div class="choice" data-toggle="wizard-checkbox"
                             @click="ManagePP" v-if="MenuPP3S">
                          <input type="checkbox" name="jobb" value="Develop">
                          <div class="card card-checkboxes card-hover-effect"
                               style="background-color: #e4b9c0">
                            <img src="../assets/img/CheckCard.png"
                                 style="width:90px; height:60px;">
                            <p align="center"
                               style="color:#333; font-family:Prompt">
                              จัดการข้อมูลบัตร (เฉพาะเจ้าหน้าที่ หน่วยรักษาความปลอดภัย)</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> <!-- wizard container -->
          <h5 align="center" style="color:#000; font-family:prompt;"><span
              style="color: #3c763d;font-weight: bold">บัตรบุคลากร => </span>ฝ่ายทรัพยากรมนุษย์ ชั้น 4
            อาคารบริหารคณะแพทยศาสตร์ ติดต่อ 074-45-1141-2 email : person@medicine.psu.ac.th</h5>
          <h5 align="center" style="color:#000; font-family:prompt;"><span
              style="color: #eea236;font-weight: bold">บัตรญาติ</span><span
              style="color: #761c19;font-weight: bold">, ผู้ประกอบการ, ร้านค้า => </span>หน่วยรักษาความปลอดภัย ชั้น
            2 อาคารบริหาร คณะแพทยศาสตร์ มหาวิทยาลัยสงขลานครินทร์ ติดต่อ 074-45-1122</h5>
        </div>

      </div><!-- end row -->
    </div> <!--  big container -->
  </div>
</template>

<script>
import axios from "axios";
import ConstData from '../Const/Const'

const queryString = require('query-string');

export default {
  name: "Home",
  data: function () {
    return {
      ShowinfoMe: '',
      position: '',
      MenuHR: false,
      MenuPP3S: false
    }
  },
  methods: {
    Login() {
      this.$session.set('vurl', ConstData.ConnectionHost + '/CardRegister/#/')
      this.$cookies.set('vurl', ConstData.ConnectionHost + '/CardRegister/#/')
      // window.location.href = ConstData.ConnectionHost + '/SingleSign/perid_login';
      window.location.href = ConstData.ConnectionHost + '/SingleSign/';
    },
    Logout() {
      this.ShowinfoMe = ''
      this.$cookies.remove('access_token')
      window.location.href = ConstData.ConnectionHost + '/CardRegister/#/';
    },
    RegisterEmp: function () {
      this.$router.push('/Card1')
    },
    RegisterRelative: function () {
      if (this.$cookies.get('access_token')) {
        this.$router.push('/Card2')
        // this.$swal.fire({
        //   icon: 'error',
        //   title: 'ขออภัย!!!',
        //   text: 'เนื่องจากระบบขัดข้อง ไม่สามารถทำบัตรญาติได้ในขณะนี้ !!!'
        // })
      } else {
        this.$swal.fire({
          icon: 'error',
          title: 'กรุณาเข้าสู่ระบบก่อนทำรายการ'
        })
      }
    },
    RegisterFollow: function () {
      this.$router.push('/Card3')
    },
    RegisterShop: function () {
      this.$router.push('/Card4')
    },
    ManageHR: function () {
      this.$router.push('/ManageCardHR')
    },
    ManagePP: function () {
      this.$router.push('/ManageCardPP3S')
    },
    parseJwt(token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    },
    initFunc: function () {

      axios.post(ConstData.ConnectionHost + '/CardRegister/service.php', {
        queryName: 'PersonalDataByPerson',
        param: btoa(encodeURIComponent(JSON.stringify({
          perid: this.parseJwt(this.$cookies.get('access_token')).perid
        })))
      }).then(res => {
        if (res.data && res.data.staffData.length > 0) {
          this.perid = res.data.staffData[0].perid;
          this.ShowinfoMe = res.data.staffData[0].name + " " + res.data.staffData[0].surname + ' ตำแหน่ง ' + res.data.staffData[0].pos_name + ' ' + res.data.staffData[0].dep_group_name

          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/depart_view/depart_types_id/2/PERID/' + this.perid).then(res => {
            if (res.data) {
              this.MenuPP3S = true
            } else {
              this.MenuPP3S = false
            }
          })

          axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/cardnew/depart_view/depart_types_id/1/PERID/' + this.perid).then(res => {
            if (res.data) {
              this.MenuHR = true
            } else {
              this.MenuHR = false
            }
          })

        }
      })
    }
  },
  mounted() {
    axios.post(ConstData.ConnectionHost + '/saveSessions.php', queryString.stringify({
      session: 'https://medhr.medicine.psu.ac.th/CardRegister/#/'
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
    if (this.$cookies.get('access_token')) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$cookies.get('access_token');
      this.initFunc()
    } else {
      if (this.$route.query.response) {
        this.uid = this.parseJwt(this.$route.query.response).uid
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$cookies.get('access_token');
        this.$cookies.set("uid", this.$route.query.response, "2h");
        this.initFunc()
      } else {
        this.$session.set('vurl', ConstData.ConnectionHost + '/CardRegister/#/')
        this.$cookies.set('vurl', ConstData.ConnectionHost + '/CardRegister/#/')
        window.location.href = ConstData.ConnectionHost + '/SingleSign/';
      }
    }
  }
}
</script>


<style>
* {
  font-family: Prompt;
}
</style>
